import React from 'react';
import {modalStyles} from '../styles';
import Button from './Button';

interface ConfirmModalProps {
  title: string;
  description: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isConfirming?: boolean;
  /** `danger` reprend la mise en page alertante des maquettes (pictogramme, CTA empilés). */
  variant?: 'default' | 'danger';
  /** Couleur du CTA de confirmation ; suit `variant` par défaut. */
  confirmVariant?: 'primary' | 'danger';
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmModal = ({
  title,
  description,
  confirmLabel = 'Confirmer',
  cancelLabel = 'Annuler',
  isConfirming = false,
  variant = 'default',
  confirmVariant,
  onConfirm,
  onCancel,
}: ConfirmModalProps) => (
  <div style={modalStyles.overlay} onClick={onCancel}>
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      // Un clic dans la boîte ne doit pas la fermer.
      onClick={event => event.stopPropagation()}
      style={{
        ...modalStyles.dialog,
        ...(variant === 'danger' ? modalStyles.dialogDanger : {}),
      }}>
      {variant === 'danger' && (
        <div style={modalStyles.warningIcon} aria-hidden="true">
          <i className="fa fa-exclamation-triangle" />
        </div>
      )}
      <h2
        style={{
          ...modalStyles.title,
          ...(variant === 'danger' ? modalStyles.titleDanger : {}),
        }}>
        {title}
      </h2>
      <p
        style={{
          ...modalStyles.description,
          ...(variant === 'danger' ? modalStyles.descriptionDanger : {}),
        }}>
        {description}
      </p>
      <div
        style={{
          ...modalStyles.actions,
          ...(variant === 'danger' ? modalStyles.actionsDanger : {}),
        }}>
        <Button variant="secondary" onClick={onCancel} disabled={isConfirming}>
          {cancelLabel}
        </Button>
        <Button
          variant={
            confirmVariant || (variant === 'danger' ? 'danger' : 'primary')
          }
          onClick={onConfirm}
          disabled={isConfirming}>
          {isConfirming ? 'Enregistrement…' : confirmLabel}
        </Button>
      </div>
    </div>
  </div>
);

export default ConfirmModal;



// WEBPACK FOOTER //
// ./src/pages/Other/MPP/QuestionBonus/components/ConfirmModal.tsx